import React, { Component } from 'react';
import cl from 'classnames';
import PropTypes from 'prop-types';
import Input from '../Input/Input';
import Button from '../Button/Button';
import Label from '../Label/Label';
import { tr } from '../utils/locale';
import Select from '../Select/Select';

export default class DynamicTag extends Component {
    constructor(props) {
        super(props);
        const { defaultTags, isSelector } = props;
        this.state = {
            inputValue: '',
            tags: isSelector ? defaultTags.map((tag) => tag.value) : defaultTags,
            error: null,
        };
    }

    handleInputChange = (e) => {
        this.setState({ inputValue: e.target.value, error: null });
    };

    handleInputConfirm = () => {
        const { inputValue, tags } = this.state;
        if (inputValue) {
            if (tags.includes(inputValue)) {
                this.setState({ error: tr('The value you’ve entered is already in the list') });
            } else {
                this.setState({
                    tags: [...tags, inputValue],
                    inputValue: '',
                });
            }
        }
    };

    handleTagRemove(tag) {
        const { tags } = this.state;
        const nextTags = tags.filter((item) => item !== tag);
        this.setState({
            tags: nextTags,
        });
    }

    handleChange = (tags) => {
        this.setState({ tags: tags.map((tag) => tag.value) });
    };

    getTags = () => {
        const { tags } = this.state;
        return tags;
    };

    renderInput = () => {
        const { inputValue, error } = this.state;
        const { placeholder, testId, isSelector, label, options, defaultTags, color } = this.props;

        return isSelector ? (
            <Select
                aria-label={`${testId}-select`}
                color={color}
                label={label}
                isMulti
                isCreatable
                options={options}
                closeMenuOnSelect={false}
                noOptionsMessage={() => tr('No options found')}
                placeholder={placeholder}
                defaultValue={defaultTags}
                onChange={this.handleChange}
            />
        ) : (
            <>
                <Input
                    placeholder={placeholder}
                    value={inputValue}
                    onChange={this.handleInputChange}
                    onBlur={this.handleInputConfirm}
                    onPressEnter={this.handleInputConfirm}
                    error={error}
                    testId={`${testId}-input`}
                />
                <Button label={tr('Add')} onClick={this.handleInputConfirm} testId={`${testId}-button`} />
            </>
        );
    };

    render() {
        const { tags } = this.state;
        const { color, testId, isSelector } = this.props;
        return (
            <div className={cl('dynamic-tag')} data-testid={testId}>
                <div className={cl('dynamic-tag__input')}>{this.renderInput()}</div>
                {!isSelector && (
                    <div className={cl('dynamic-tag__tags')}>
                        {tags.map((item) => (
                            <Label
                                color={color}
                                key={`label_${item}`}
                                closable
                                label={item}
                                closeCb={() => {
                                    this.handleTagRemove(item);
                                }}
                                testId={`${testId}-label`}
                            />
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

DynamicTag.defaultProps = {
    defaultTags: [],
    placeholder: '',
    color: '',
    testId: 'dynamic-tag',
    isSelector: false,
};

DynamicTag.propTypes = {
    defaultTags: PropTypes.array,
    placeholder: PropTypes.string,
    color: PropTypes.string,
    testId: PropTypes.string,
    isSelector: PropTypes.bool,
    ...Select.propTypes,
};
